export const GET_USER_FILTERS = 'GET_USER_FILTERS'
export const GET_FILTER_DETAILS = 'GET_FILTER_DETAILS'
